import { useState, useEffect } from "react";
import { useTheme, useMediaQuery } from "@mui/material";

/**
 * @param {React.RefObject} anchorRef            
 * @param {boolean}         isOpen                
 * @param {number}          [estimatedPopoverHeight=400] 
 */
export function UsePopoverPosition(anchorRef, isOpen, estimatedPopoverHeight = 400) {
  const muiTheme  = useTheme();
  const matchesSm = useMediaQuery(muiTheme.breakpoints.down("sm")); // < 600 px

  const [anchorOriginVert,    setAnchorOriginVert]    = useState("bottom");
  const [transformOriginVert, setTransformOriginVert] = useState("top");

  useEffect(() => {
    if (!isOpen || !anchorRef?.current) return;

    const rect = anchorRef.current.getBoundingClientRect();

    if (!matchesSm) {
      // Desktop: flip above if not enough room below
      if (rect.bottom + estimatedPopoverHeight > window.innerHeight) {
        setAnchorOriginVert("top");
        setTransformOriginVert("bottom");
      } else {
        setAnchorOriginVert("bottom");
        setTransformOriginVert("top");
      }
    }
    // Mobile: always opens below — handled by mobileOverrideProps
  }, [isOpen, anchorRef, matchesSm, estimatedPopoverHeight]);

  const paperMaxHeight = matchesSm ? "calc(100dvh - 100px)" : "700px";
  const paperWidth     = matchesSm ? "calc(100vw - 24px)"   : "93%";

  const getMobileAnchorPosition = () => {
    if (!anchorRef?.current) return { top: 90, left: window.innerWidth / 2 };
    const rect = anchorRef.current.getBoundingClientRect();
    return {
      top:  rect.bottom + 8,
      left: rect.left + rect.width / 2,
    };
  };

  const mobileOverrideProps = matchesSm
    ? {
        anchorReference: "anchorPosition",
        anchorPosition:  getMobileAnchorPosition(),
        transformOrigin: { vertical: "top", horizontal: "center" },
      }
    : {};

  const paperSx = {
    width:     paperWidth,
    maxWidth:  "700px",
    maxHeight: paperMaxHeight,
    overflowY: "auto",
    scrollbarWidth:  "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
    WebkitOverflowScrolling: "touch",
    zIndex: 99999,
    borderRadius: matchesSm ? "12px" : "8px",
    "& > *:last-child": { pb: 2 },
  };

  return {
    matchesSm,
    anchorOriginVert,
    transformOriginVert,
    paperSx,
    mobileOverrideProps,
  };
}

